export const iconFontAwesomeBuildingsHouseFire = (
	<i className="fa-solid fa-house-fire"></i>
);
